import Env from '../../base/env';
import Component from 'gia/Component';
import hoverIntent from 'hoverintent'
import CursorFollow from '../../fx/CursorFollow';
import gsap from 'gsap';
import easesCustom from '../../fx/CustomEases';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);
import lozad from 'lozad'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe'

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.items = this.DOM.view.querySelectorAll('.js-item')
    this.DOM.hovers = this.DOM.view.querySelectorAll('.js-hover')
    this.DOM.externals = this.DOM.view.querySelectorAll('.js-external')
    this.DOM.bg = this.DOM.view.querySelector('.js-bg')
    this.DOM.textReceptor = this.DOM.view.querySelector('.js-receptor')
    this.DOM.cache = this.DOM.view.querySelector('.js-cache')
    // Vars
    this.VARS = {}
    this.VARS.lineThreshold = (Env.mobileCSS)?.7:.2
    this.IS_HOVERING = false;
    //! Fns
    this.preload()
    this.events()
    this.makeSticky()
    this.zoom()
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);

  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha:1
        },
        {
          autoAlpha:0,
          ease:easesCustom.cubic,
          duration:.8
        }
      )
    ])
  }

  disableHover()
  {
    for(let item of this.DOM.hovers) {
      item.classList.add('tw-pointer-events-none')
    }
  }

  enabledHover()
  {
    for(let item of this.DOM.hovers) {
      item.classList.remove('tw-pointer-events-none')
    }
  }


  events()
  {
    for(let item of this.DOM.hovers) {
      hoverIntent(item,
        //! IN
        ()=> {
          if(Env.mobileCSS == false) {
            this.disableHover()
            item.classList.add('tw-pointer-events-auto')
            this.hoverIn(item)
          }


        //! OUT
        }, ()=> {
          if(Env.mobileCSS == false) {
            this.hoverOut(item)
            item.classList.remove('tw-pointer-events-auto')
          }
        }).options({
          timeout: 400,
          interval: 100
        });
      }
      if(Env.mobileCSS) {
        for(let item of this.DOM.externals) {
          item.addEventListener('click',()=>{
            item.classList.toggle('clickable')
          })
        }
      }


  }

  hoverIn(item)
  {

    item.classList.add('tw-pointer-events-auto')
    this.DOM.textReceptor.innerHTML = item.querySelector('.js-text').innerHTML
    this.FX = {}
    this.FX.title = new SplitText(this.DOM.textReceptor, { type:'chars' })
    this.FX.titleWrapper = new SplitText(this.DOM.textReceptor, { type:'lines' , linesClass:'tw-overflow-hidden', lineThreshold:this.VARS.lineThreshold })
    gsap.set(this.FX.title.chars, { y : '120%' })
    setTimeout(() => {
      this.sticky.refresh()
    }, 100);
    gsap.killTweensOf(this.DOM.textReceptor)
    gsap.set(this.DOM.textReceptor,{ autoAlpha:1 })
    gsap.to(
      this.DOM.bg,
      {
        backgroundColor:'#fff',
        ease:easesCustom.cubic,
        duration:.8
      }
    )
    gsap.to(
      this.DOM.items,
      {
        autoAlpha:0,
        ease:'quint.inOut',
        duration:.8
      }
    )
    let i = 0
    for(let line of this.FX.titleWrapper.lines) {
      const modulo = i % 2
      const chars = line.querySelectorAll('div');
      if(modulo == 0) {
        gsap.fromTo(
          chars,
          {
            y:'120%'
          },
          {
            y:0,
            duration:.8,
            ease:easesCustom.quart,
            stagger:.05,
            delay:.1
          }
        )
      } else {
        gsap.fromTo(
          chars,
          {
            y:'-120%'
          },
          {
            y:0,
            duration:.8,
            ease:easesCustom.quart,
            stagger:-.05,
            delay:.1
          }
        )
      }
      i++
    }


    gsap.killTweensOf(item)
    gsap.set(
      item,
      {
        autoAlpha:1,
      }
    )
  }

  hoverOut(item)
  {
    let i = 0
    for(let line of this.FX.titleWrapper.lines) {
      const modulo = i % 2
      const chars = line.querySelectorAll('div');
      if(modulo == 0) {
        gsap.to(
          chars,
          {
            y:'120%',
            duration:.5,
            ease:easesCustom.quart,
          }
        )
      } else {
        gsap.to(
          chars,
          {
            y:'-120%',
            duration:.5,
            ease:easesCustom.quart,

          }
        )
      }
      i++
    }

    gsap.to(
      this.DOM.bg,
      {
        backgroundColor:'#181412',
        ease:easesCustom.cubic,
        duration:.8
      }
    )
    gsap.to(
      this.DOM.textReceptor,
      {
        autoAlpha:0,
        ease:easesCustom.cubic,
        duration:.8
      }
    )
    gsap.to(
      this.DOM.items,
      {
        autoAlpha:1,
        ease:'quint.inOut',
        duration:.8,
        onComplete:()=>{
          this.enabledHover()
        }
      }
    )
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.textReceptor,
      start:'center center',
      pin:true,
      pinSpacing:false,
      end: () => ScrollTrigger.maxScroll(document.body),
      invalidateOnRefresh: true
    })
  }

  preload()
  {
    for(let item of this.DOM.items) {
      const DOM = {}
      DOM.img = item.querySelector('.js-preload')
      if(DOM.img != null) {
        const observer = lozad(DOM.img,{
          loaded:(e)=>{
            item.classList.add('tw-overflow-hidden')
            // gsap.set(DOM.img, { scale:1.05 })
          }
        });
        observer.observe();
        observer.triggerLoad(DOM.img)
      }
    }
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 50%',
    })
  }

  unmount()
  {
    this.sticky.kill(true)
    this.st.kill(true)
  }

  zoom()
  {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.DOM.view,
      children: '.js-zoom',
      pswpModule: PhotoSwipe,
      arrowPrevSVG: LIGTHBOX_CONFIG.arrowSvg,
      arrowNextSVG: LIGTHBOX_CONFIG.arrowSvg,
      zoom: false,
      counter: false,
      closeSVG:LIGTHBOX_CONFIG.closeSvg,
      showHideAnimationType: 'zoom',
      showAnimationDuration: 800,
      hideAnimationDuration: 400,
      easing:LIGTHBOX_CONFIG.easing,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 1,
      maxZoomLevel: 2,
      bgOpacity:.95
    });

    this.lightbox.init();

  }
}
